<template>
  <v-dialog
    :value="showDeepDeeDialog"
    v-if="showDeepDeeDialog"
    persistent
    scrollable
    content-class="help-dialog">
    <v-card>
      <dialog-header text="DeepDee Information" @closeModal="closeDeepDeeDialog" />
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <span style="font-weight: bold">Image requirements for DeepDee Analysis Tool</span>
            </v-col>
            <v-col class="d-flex justify-center">
              <ul>
                  <li>Angle of view: 30° - 45°</li>
                  <li>Image not less than: 1024x1024</li>
                  <li>Macula centered</li>
                  <li>Full color image</li>
                  <li>Image is sharp and well exposed</li>
                  <li>Area around macula and optic nerve head clearly visible</li>
                  <li>No large reflexes or shadows</li>
                  <li>Main vessels clearly visible</li>
              </ul>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogHeader from "../dialogs/DialogHeader";
import { mapState, mapMutations } from "vuex";

export default {
  name: "deepDeeInfoDialog",
  components: { dialogHeader },

  computed: {
    ...mapState(["showDeepDeeDialog"])
  },
  methods: {
    ...mapMutations(["closeDeepDeeDialog"])
  }
}
</script>

<style lang="scss">
.deepdee-dialog {
  max-width: 600px;
}
</style>